export interface SystemNotification {
    orgId?: string;
    userId?: string;
    groupId?: string;
    flowId?: string;
    workOrderId?: string;
    redirectUrl?: string;
    description: string;
    level: SystemNotificationLevel;
    type: string;
    timestamp: string;
    flowIsOnBehalf?: boolean;
    flowCreatedById?: string;
    applicationNumber?: string;
}

export enum SystemNotificationLevel {
    Information = "Information",
    Alert = "Alert"
}

export interface SystemNotificationRequest {
	days: number;
}